// AI Coding
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface QRCodeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  title?: string;
}

export const QRCodeModal = ({
  open,
  onOpenChange,
  value,
  title,
}: QRCodeModalProps) => {
  const { t } = useTranslation();
  const displayTitle = title || t("common.qr_code", "QR Code");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] sm:max-w-[320px] rounded-3xl p-6 flex flex-col items-center gap-6 border-none">
        <DialogHeader>
          <DialogTitle className="text-center font-poppins text-[18px] font-semibold">
            {displayTitle}
          </DialogTitle>
        </DialogHeader>
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 italic">
          <QRCodeSVG value={value} size={200} />
        </div>
        <p className="text-[14px] text-gray-500 font-poppins text-center break-all px-2">
          {value}
        </p>
      </DialogContent>
    </Dialog>
  );
};
